import styled from "styled-components";
import Variables from "../../../../../assets/styleVariables";

export const CurrentProjectContainer = styled.div`
  width: 100%;
  background-color: ${Variables.colors.complementary_light};
  position: relative;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
  .top-row {
    display: flex;
    padding: 0 16px 0 10px;
    position: relative;
    justify-content: space-between;
    .current-project-name {
      color: ${Variables.colors.complementary_900};
      font-size: ${Variables.font_sizes.x_medium};
      height: 100%;
      max-width: 200px;
      padding: 8px 0;
      .project-name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .user-name {
        font-size: ${Variables.font_sizes.x_small};
        color: ${Variables.colors.complementary_600};
        line-height: 1.58;
        padding-top: 6px;
        max-width: 200px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        direction: ltr;
      }
    }
    .click-hint-text {
      display: flex;
      align-items: flex-end;
      font-size: ${Variables.font_sizes.small};
      color: ${Variables.colors.primary_700};
      padding: 8px;
      .wrapper {
        display: flex;
        align-items: center;
      }
    }
  }
`;
